import { render, staticRenderFns } from "./BusinessForeignContractor.vue?vue&type=template&id=c06fd780&scoped=true&"
import script from "./BusinessForeignContractor.vue?vue&type=script&lang=ts&"
export * from "./BusinessForeignContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06fd780",
  null
  
)

export default component.exports